import { render, staticRenderFns } from "./FedExLabel.vue?vue&type=template&id=17fc5aa9&scoped=true"
import script from "./FedExLabel.vue?vue&type=script&lang=js"
export * from "./FedExLabel.vue?vue&type=script&lang=js"
import style0 from "./FedExLabel.vue?vue&type=style&index=0&id=17fc5aa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc5aa9",
  null
  
)

export default component.exports